import { useRef } from 'react';
import { src } from '../../../utils/common';
import styles from './style.module.scss';
import { useUserAgentInfo } from '../../../context/user-agent';
import { WebPNextImage as Image, WebPNextImage } from '../../WebPImage';

const GalleryMobile = ({ pics }) => {
  return (
    <div className={styles['gallery-slider']}>
      {pics.map((item, index) => (
        <div key={index} className={styles['gallery-item']}>
          <WebPNextImage src={item} alt="活动现场" layout="fill" />
        </div>
      ))}
    </div>
  );
};

const GalleryPc = ({ pics }) => {
  return (
    <div className={styles['activity-img']}>
      <WebPNextImage src={pics} alt="活动现场" layout="fill" />
    </div>
  );
};

const Gallery = ({ data }) => {
  const { isMobile } = useUserAgentInfo();
  return (
    <div className={styles['gallery-wrapper']}>
      <div className={styles['title']}>{data.title}</div>
      <div className={styles['gallery-container']}>
        {isMobile ? (
          <GalleryMobile pics={data.pics} />
        ) : (
          <GalleryPc pics={data.spirit} />
        )}
      </div>
    </div>
  );
};

export default Gallery;
